export enum StatusCodeResponse {
  Unauthorized = -1,
  OK = 0,
  BadRequest = 1
}
